(function () {
  const COD_FEE = 6.90;

  function parsePrice(text) {
    if (!text) return 0;

    let value = text
      .replace(/[^\d.,-]/g, '')
      .replace(/\./g, '')
      .replace(',', '.');

    return parseFloat(value) || 0;
  }

  function formatPrice(value) {
    return new Intl.NumberFormat('it-IT', {
      style: 'currency',
      currency: 'EUR'
    }).format(value);
  }

  function initCodPreview() {

    // Cerchiamo i blocchi totale sia nel carrello che nel cart drawer
    const totalBlocks = document.querySelectorAll(
      '.totals, .cart__footer .totals, cart-drawer .totals, .drawer__footer .totals'
    );

    totalBlocks.forEach(function (totals) {

      if (totals.querySelector('.cod-preview-box')) {
        updateCodPreview(totals);
        return;
      }

      const totalValue = totals.querySelector(
        '.totals__total-value, .totals__subtotal-value'
      );

      if (!totalValue) return;

      const box = document.createElement('div');

      box.className = 'cod-preview-box';

      box.innerHTML = `
        <div class="cod-preview-selector">
          <label>
            <input type="checkbox" class="cod-preview-checkbox">
            <span>Pagamento alla consegna</span>
          </label>
        </div>

        <div class="cod-preview-values" style="display:none;">
          <div class="cod-preview-row">
            <span>Contrassegno</span>
            <strong>+${formatPrice(COD_FEE)}</strong>
          </div>

          <div class="cod-preview-row cod-preview-total">
            <span>Totale con contrassegno</span>
            <strong class="cod-preview-final-total"></strong>
          </div>
        </div>
      `;

      totals.appendChild(box);

      const checkbox = box.querySelector('.cod-preview-checkbox');

      checkbox.addEventListener('change', function () {

        const values = box.querySelector('.cod-preview-values');

        if (this.checked) {
          values.style.display = '';
        } else {
          values.style.display = 'none';
        }

        updateCodPreview(totals);
      });

      updateCodPreview(totals);
    });
  }


  function updateCodPreview(totals) {

    const box = totals.querySelector('.cod-preview-box');

    if (!box) return;

    const totalValue = totals.querySelector(
      '.totals__total-value, .totals__subtotal-value'
    );

    if (!totalValue) return;

    const currentTotal = parsePrice(totalValue.textContent);

    const finalTotal = currentTotal + COD_FEE;

    const output = box.querySelector('.cod-preview-final-total');

    if (output) {
      output.textContent = formatPrice(finalTotal);
    }
  }


  document.addEventListener('DOMContentLoaded', initCodPreview);


  // Serve soprattutto per i cart drawer Shopify,
  // che vengono aggiornati senza ricaricare la pagina.
  const observer = new MutationObserver(function () {
    initCodPreview();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();